export const createDemoSpreadsheetData = () => ({
  mapping: {
    "First Name": "First name",
    "Last Name": "Last name",
    "Full Name": "Full name",
    "Company": "Company",
    "Position": "Position",
    "Email": "Email",
    "Attendee Type": "Attendee type",
    "QR Code": "QR code",
    "Barcode": "Barcode 128",
  },
  fileData: {
    headers: [
      "First Name",
      "Last Name",
      "Full Name",
      "Company",
      "Position",
      "Email",
      "Attendee Type",
      "QR Code",
      "Barcode",
    ],
    data: [
      [
        "John",
        "Cooper",
        "John Cooper",
        "Cloudline Labs",
        "Product Designer",
        "john.cooper@example.com",
        "Speaker",
        "https://badgeflow.app/demo/john-cooper",
        "SPK-1001",
      ],
      [
        "Jordan",
        "Smith",
        "Jordan Smith",
        "Northbridge Systems",
        "Engineering Manager",
        "jordan.smith@example.com",
        "Attendee",
        "https://badgeflow.app/demo/jordan-smith",
        "ATT-2048",
      ],
      [
        "Priya",
        "Patel",
        "Priya Patel",
        "Helio Ventures",
        "Investor",
        "priya.patel@example.com",
        "VIP",
        "https://badgeflow.app/demo/priya-patel",
        "VIP-3310",
      ],
      [
        "Marcus",
        "Chen",
        "Marcus Chen",
        "Riverstone Media",
        "Video Producer",
        "marcus.chen@example.com",
        "Attendee",
        "https://badgeflow.app/demo/marcus-chen",
        "ATT-5521",
      ],
      [
        "Elena",
        "Kowalski",
        "Elena Kowalski",
        "Atlas Robotics",
        "Solutions Architect",
        "elena.kowalski@example.com",
        "VIP",
        "https://badgeflow.app/demo/elena-kowalski",
        "VIP-8892",
      ],
    ],
  },
});

